var _rect, _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame2762(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 76,
    viewBox: "0 0 100 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 92,
    height: 68,
    rx: 34,
    stroke: "black",
    strokeWidth: 8
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_296_47",
    maskUnits: "userSpaceOnUse",
    x: 31.5,
    y: 16,
    width: 35,
    height: 43,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 31.5,
    y: 16,
    width: 35,
    height: 43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1285 54.6949C60.9092 55.739 57.4288 56.261 53.6874 56.261C40.636 56.261 34.1103 49.7788 34.1103 36.8144C34.1103 24.5461 40.636 18.4119 53.6874 18.4119C57.4288 18.4119 60.9092 18.934 64.1285 19.9781V24.1546C60.9092 22.9364 57.6028 22.3274 54.2095 22.3274C44.0294 22.3274 38.9393 27.1564 38.9393 36.8144C38.9393 47.1685 44.0294 52.3456 54.2095 52.3456C57.6028 52.3456 60.9092 51.7365 64.1285 50.5184V54.6949Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1285 54.6949C60.9092 55.739 57.4288 56.261 53.6874 56.261C40.636 56.261 34.1103 49.7788 34.1103 36.8144C34.1103 24.5461 40.636 18.4119 53.6874 18.4119C57.4288 18.4119 60.9092 18.934 64.1285 19.9781V24.1546C60.9092 22.9364 57.6028 22.3274 54.2095 22.3274C44.0294 22.3274 38.9393 27.1564 38.9393 36.8144C38.9393 47.1685 44.0294 52.3456 54.2095 52.3456C57.6028 52.3456 60.9092 51.7365 64.1285 50.5184V54.6949Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1285 54.6949L64.7455 56.5973L66.1285 56.1488V54.6949H64.1285ZM64.1285 19.9781H66.1285V18.5242L64.7455 18.0757L64.1285 19.9781ZM64.1285 24.1546L63.4207 26.0251L66.1285 27.0497V24.1546H64.1285ZM64.1285 50.5184H66.1285V47.6233L63.4207 48.6478L64.1285 50.5184ZM63.5115 52.7924C60.5113 53.7655 57.2412 54.261 53.6874 54.261V58.261C57.6164 58.261 61.3071 57.7125 64.7455 56.5973L63.5115 52.7924ZM53.6874 54.261C47.4666 54.261 43.1691 52.7171 40.414 49.9804C37.6615 47.2462 36.1103 42.9849 36.1103 36.8144H32.1103C32.1103 43.6083 33.822 49.0703 37.5951 52.8183C41.3658 56.5638 46.8568 58.261 53.6874 58.261V54.261ZM36.1103 36.8144C36.1103 31.0213 37.6451 27.0354 40.3744 24.4698C43.1269 21.8824 47.4402 20.4119 53.6874 20.4119V16.4119C46.8832 16.4119 41.4079 18.0085 37.6347 21.5553C33.8383 25.1239 32.1103 30.3392 32.1103 36.8144H36.1103ZM53.6874 20.4119C57.2412 20.4119 60.5113 20.9075 63.5115 21.8806L64.7455 18.0757C61.3071 16.9605 57.6164 16.4119 53.6874 16.4119V20.4119ZM62.1285 19.9781V24.1546H66.1285V19.9781H62.1285ZM64.8363 22.284C61.3941 20.9815 57.8482 20.3274 54.2095 20.3274V24.3274C57.3575 24.3274 60.4242 24.8913 63.4207 26.0251L64.8363 22.284ZM54.2095 20.3274C48.8366 20.3274 44.4354 21.5998 41.3803 24.4982C38.3055 27.4153 36.9393 31.6495 36.9393 36.8144H40.9393C40.9393 32.3214 42.1181 29.312 44.1334 27.4001C46.1684 25.4694 49.4022 24.3274 54.2095 24.3274V20.3274ZM36.9393 36.8144C36.9393 42.2913 38.2858 46.768 41.3307 49.865C44.3818 52.9682 48.8025 54.3456 54.2095 54.3456V50.3456C49.4364 50.3456 46.222 49.1345 44.183 47.0606C42.1379 44.9805 40.9393 41.6916 40.9393 36.8144H36.9393ZM54.2095 54.3456C57.8482 54.3456 61.3941 53.6914 64.8363 52.389L63.4207 48.6478C60.4242 49.7816 57.3575 50.3456 54.2095 50.3456V54.3456ZM62.1285 50.5184V54.6949H66.1285V50.5184H62.1285Z",
    fill: "black",
    mask: "url(#path-2-outside-1_296_47)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2762);
export default __webpack_public_path__ + "static/media/Frame 2762.8daad722d93528cfeb8c3f37ff0e2413.svg";
export { ForwardRef as ReactComponent };